export function asyncMapInSeries(array, operation) {
  return array.reduce(
    (p, v) => p.then((a) => operation(v).then((r) => a.concat([r]))),
    Promise.resolve([]),
  )
}
